import "../../styles/FilterCareer.css";
import { Container, Row, Col } from "react-bootstrap";
import Filter from "../../assets/filter.png";
import Arrow3 from "../../assets/arrow3.png";
import Shape from "../../assets/Vector (22).png";
import Upload from "../../assets/upload-svgrepo-com (1) 1.png";
import Close from "../../assets/close.png";
import Card from "./Card";
import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import Search from "../../assets/search.png";
import "../../styles/Landing.css";
import "../../styles/CareerLanding.css";
import {
   careersApiSlice,
   useCreateDirectEmployeeMutation,
   useGetAllCareersQuery,
   useGetDepartmentsQuery,
} from "../../redux/features/careers/careersApiSlice";
import { useDispatch } from "react-redux";
import useInputField from "../../hooks/useInputField";
import Swal from "sweetalert2";
import { validCvExtension } from "../../data/rules";

function FilterCareer() {
   // ################### RTK QUERY ###################
   const { data: allCareers } = useGetAllCareersQuery();
   const { data: departments, isSuccess } = useGetDepartmentsQuery();
   const [createDirectEmployee, { isLoading }] =
      useCreateDirectEmployeeMutation();

   // ################### REACT HOOKS ###################
   const [careers, setCareers] = useState([]);
   const [cvFile, setCvFile] = useState(null);
   const [otherFile, setOtherFile] = useState(null);
   useEffect(() => {
      setCareers(allCareers);
   }, []);

   // ################### CUSTOM HOOKS ###################
   const [employeeInfo, focusedInput, handleEmployeeInfo, clearData] =
      useInputField({
         first_name: "",
         last_name: "",
         email: "",
         phone: "",
      });

   // ################### REDUX HOOKS ###################
   const dispatch = useDispatch();

   // ################### VALIDATION ###################
   const validateEmployeeInfo = () => {
      const emailValidation = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

      if (!Object.values(employeeInfo).every((e) => e !== "")) {
         Swal.fire({
            icon: "error",
            text: "الرجاء ملىء جميع الحقول.",
         });
      } else if (!emailValidation.test(employeeInfo.email)) {
         Swal.fire({
            icon: "error",
            text: "الرجاء إدخال عنوان بريد الكتروني صحيح.",
         });
      } else if (+employeeInfo.phone <= 0 || employeeInfo.phone.length < 4) {
         Swal.fire({
            icon: "error",
            text: "الرجاء إدخال رقم هاتف صحيح.",
         });
      } else if (!cvFile) {
         Swal.fire({
            icon: "error",
            text: "الرجاء رفع ملف ال CV.",
         });
      } else {
         return true;
      }
   };

   // ################### HANDLER ###################
   const handleSearch = (searchval) => {
      if (searchval) {
         const regexp = new RegExp(`${searchval}`, "i");
         const filteredData = careers.filter((career) =>
            Object.values(career).some((val) => regexp.test(val))
         );
         setCareers(filteredData);
      } else setCareers(allCareers);
   };
   const handleGetAllCareer = async () => {
      try {
         const res = await dispatch(
            careersApiSlice.endpoints.getAllCareers.initiate()
         ).unwrap();
         setCareers(res);
      } catch (err) {
         console.log(err);
      }
   };
   const handleGetCareerByDepartment = async (departmentID) => {
      try {
         const res = await dispatch(
            careersApiSlice.endpoints.getCareersByDepartment.initiate(
               departmentID
            )
         ).unwrap();
         setCareers(res);
      } catch (err) {
         console.log(err);
      }
   };
   const handleSorting = (sortingWay) => {
      if (sortingWay === "oldest") {
         const oldest = [...careers].sort(
            (a, b) => new Date(a.created_at) - new Date(b.created_at)
         );
         setCareers(oldest);
      } else if (sortingWay === "newest") {
         const newest = [...careers].sort(
            (a, b) => new Date(b.created_at) - new Date(a.created_at)
         );
         setCareers(newest);
      }
   };
   const handleCreateEmployee = async (e) => {
      try {
         e.preventDefault();
         if (validateEmployeeInfo()) {
            const data = new FormData();
            data.append("first_name", employeeInfo.full_name);
            data.append("last_name", employeeInfo.full_address);
            data.append("email", employeeInfo.email);
            data.append("phone", employeeInfo.phone);
            data.append("file_one_path", cvFile);

            if (otherFile) data.append("file_two_path", otherFile);

            await createDirectEmployee(data).unwrap();

            clearData();
            setCvFile(null);
            setOtherFile(null);
            closePopup();

            Swal.fire({
               text: "تم تقديم طلب التوظيف بنجاح.",
               icon: "success",
            });
         }
      } catch (err) {
         // TODO: Add alert from sweetAlert2 to show it when get error
         console.log(err);
      }
   };

   let ref = useRef();
   let pop = useRef();

   const [isOpen, setIsOpen] = useState(false);
   const [isRotate, setRotate] = useState("false");

   function handle() {
      setRotate(!isRotate);
      setIsOpen((isOpen) => !isOpen);
   }
   function openPopup() {
      ref.current.classList.add("block");
      ref.current.classList.remove("none");
      pop.current.classList.toggle("block");
      pop.current.classList.toggle("none");
   }
   function closePopup() {
      ref.current.classList.add("none");
      ref.current.classList.remove("block");
      pop.current.classList.toggle("block");
      pop.current.classList.toggle("none");
   }
   let links = document.querySelectorAll(".lnk");
   const handleCheck = (e) => {
      const checkVal = e.target.value;
      links.forEach((lnk) => {
         let attr = lnk.getAttribute("data-name");
         // console.log(attr);
         if (checkVal === "all") {
            lnk.style.display = "block";
         } else if (checkVal === attr) {
            lnk.style.display = "block";
         } else {
            lnk.style.display = "none";
         }
      });
   };

   // ################### CONTENT ###################
   let departmentsContent;
   if (isSuccess) {
      departmentsContent = (
         <>
            {departments?.data?.map((department) => (
               <div className="type" key={department?.id}>
                  <input
                     type="radio"
                     name="check"
                     className="cb01"
                     id={department?.name}
                     value={department?.name}
                     onClick={() => handleGetCareerByDepartment(department?.id)}
                     onChange={handleCheck}
                  />
                  <label htmlFor={department?.name}>{department?.name}</label>
               </div>
            ))}
         </>
      );
   }

   return (
      <>
         <div className="landing">
            <div className="to-search">
               <Container>
                  <div className="rows">
                     <div className="head">
                        <h2>
                           <span>{careers?.length} عمل </span>
                           متاح الآن
                        </h2>
                     </div>
                     <div className="search">
                        <form action="">
                           <div className="input-search">
                              <input
                                 type="search"
                                 placeholder="ادخل كلمة مفتاحية"
                                 onChange={(e) =>
                                    handleSearch(e.target.value.trim())
                                 }
                              />
                              <button>
                                 <img src={Search} alt="search-icon" />
                                 بحث
                              </button>
                           </div>
                        </form>
                     </div>
                  </div>
               </Container>
            </div>
         </div>
         <div className="filter">
            <div id="ccc" ref={pop} className="none">
               <div className="head">
                  <h5>طلب توظيف</h5>
                  <img
                     src={Close}
                     alt=""
                     className="close-nested-popup"
                     onClick={closePopup}
                  />
               </div>
               <p>هل تناسبك هذه الوظيفة ؟ الرجاء ملئ المعلومات الخاصة بك</p>
               <div className="reply-time">
                  <img src={Shape} alt="" />
                  <span>متوسط وقت الرد على طلبك 72 ساعة</span>
               </div>
               <div className="add-items">
                  <form onSubmit={handleCreateEmployee}>
                     <div className="name">
                        <input
                           type="text"
                           placeholder="الاسم الاول"
                           onChange={handleEmployeeInfo}
                           name="first_name"
                           value={employeeInfo.first_name}
                           ref={focusedInput}
                        />
                        <input
                           type="text"
                           placeholder="الاسم الثاني"
                           onChange={handleEmployeeInfo}
                           name="last_name"
                           value={employeeInfo.last_name}
                        />
                     </div>
                     <input
                        type="email"
                        placeholder="الايميل*"
                        onChange={handleEmployeeInfo}
                        name="email"
                        value={employeeInfo.email}
                     />
                     <input
                        type="number"
                        placeholder="رقم الهاتف*"
                        onChange={handleEmployeeInfo}
                        name="phone"
                        value={employeeInfo.phone}
                     />

                     <h6>
                        <span>تحميل السيرة الذاتية</span>
                        <span>pdf,docx</span>
                     </h6>
                     <div>
                        <div className="upload">
                           <img src={Upload} alt="" />
                           <p>قم بتحميل ملفك هنا</p>
                           <input
                              type="file"
                              multiple
                              onChange={(e) => {
                                 const file = e.target.files[0];
                                 if (validCvExtension.includes(file.type))
                                    setCvFile(e.target.files[0]);
                                 else
                                    Swal.fire({
                                       icon: "error",
                                       title: "خطأ...",
                                       text: "أنواع الملفات المسموحة (pdf, docs)",
                                       width: 300,
                                    });
                              }}
                              name="file_one_path"
                           />
                        </div>
                        {cvFile && (
                           <div className="maping">
                              <div className="active-file">
                                 <p>Selected File: {cvFile.name}</p>
                                 <button
                                    onClick={() => setCvFile(null)}
                                    className="remove"
                                 >
                                    x
                                 </button>
                              </div>
                           </div>
                        )}
                     </div>
                     <h6>
                        <span>تحميل مرفقات اخرى</span>
                        <span>pdf,docx</span>
                     </h6>
                     <div>
                        <div className="upload">
                           <img src={Upload} alt="" />
                           <p>قم بتحميل ملفك هنا</p>
                           <input
                              type="file"
                              multiple
                              onChange={(e) => {
                                 const file = e.target.files[0];
                                 if (validCvExtension.includes(file.type))
                                    setOtherFile(e.target.files[0]);
                                 else
                                    Swal.fire({
                                       icon: "error",
                                       title: "خطأ...",
                                       text: "أنواع الملفات المسموحة (pdf, docs)",
                                       width: 300,
                                    });
                              }}
                              name="file_two_path"
                           />
                        </div>
                        {otherFile && (
                           <div className="maping">
                              <div className="active-file">
                                 <p>Selected File: {otherFile.name}</p>
                                 <button
                                    onClick={() => setOtherFile(null)}
                                    className="remove"
                                 >
                                    x
                                 </button>
                              </div>
                           </div>
                        )}
                     </div>

                     <div className="submit">
                        {isLoading ? (
                           <input
                              type="submit"
                              disabled
                              value="جاري الإرسال ..."
                           />
                        ) : (
                           <input type="submit" value="ارسال" />
                        )}
                     </div>
                  </form>
               </div>
            </div>
            <Container>
               <Row>
                  <Col md={3} xs={12} className="col">
                     <div className="model-overlay" ref={ref}></div>

                     <h6>
                        {" "}
                        <img src={Filter} alt="" />
                        فلترة :
                     </h6>
                     <h5 onClick={handle}>
                        حسب القسم
                        <img
                           src={Arrow3}
                           alt="arrow"
                           className={isRotate ? "rotate" : "no-rotate"}
                        />
                     </h5>
                     {isOpen && (
                        <form className="type-form">
                           <div className="type">
                              <input
                                 type="radio"
                                 name="check"
                                 id="all"
                                 className="cb01"
                                 value="all"
                                 onChange={handleCheck}
                                 onClick={handleGetAllCareer}
                              />{" "}
                              <label htmlFor="all">الكل</label>
                           </div>
                           {departmentsContent}
                        </form>
                     )}

                     <button onClick={openPopup}>التقديم مباشرة</button>
                  </Col>
                  <Col md={9} xs={12} className="col">
                     <form>
                        <select onChange={(e) => handleSorting(e.target.value)}>
                           <option value="newest">حسب الاحدث</option>
                           <option value="oldest">حسب الاقدم</option>
                        </select>
                     </form>
                     <div className="cards">
                        {careers?.length > 0 ? (
                           careers.map((career) => {
                              if (career?.["situation Visible"] === 1) {
                                 return (
                                    <Link
                                       to={`/career/${career?.["career id"]}`}
                                       className="lnk"
                                       data-name={career?.["department name"]}
                                       key={career?.["career id"]}
                                    >
                                       <Card
                                          department={
                                             career?.["department name"]
                                          }
                                          name={career?.["career name"]}
                                          salery={career?.salary}
                                          experience={career?.experience}
                                          arr={career?.skills}
                                          description={career?.description}
                                          update={career?.updated_at}
                                       />
                                    </Link>
                                 );
                              }
                           })
                        ) : (
                           <p>لا يوجد وظائف.</p>
                        )}
                     </div>
                  </Col>
               </Row>
            </Container>
         </div>
      </>
   );
}

export default FilterCareer;
